// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b51d605a","952":"49e696be"}[chunkId] + ".chunk.js";
};